/**
 * Lexical EditorState JSON shape — opaque pass-through. duro-lexical-multi
 * owns the internal structure (paragraphs, headings, lists, tables,
 * embeds, etc.) and provides `serializeToHtml(state, theme)` (the S4
 * spike's output, shipped in duro-lexical-multi@0.2.0). We accept any
 * JSON object so the schema doesn't have to mirror Lexical's evolving
 * node-type set — drift between duro-lexical-multi and a hand-rolled
 * mirror here is exactly the failure mode T1.2 avoids.
 *
 * The materialize step (T3.1) decodes here, then hands the
 * `editorState` value to `serializeToHtml`.
 */
import * as Schema from "effect/Schema";

const JsonValue: Schema.Schema<JsonValue, JsonValue> = Schema.suspend(() =>
  Schema.Union(
    Schema.Null,
    Schema.Boolean,
    Schema.Number,
    Schema.String,
    Schema.Array(JsonValue),
    Schema.Record({ key: Schema.String, value: JsonValue }),
  ),
);
type JsonValue =
  | null
  | boolean
  | number
  | string
  | ReadonlyArray<JsonValue>
  | { readonly [k: string]: JsonValue };

export const LexicalEditorStateJson = Schema.Struct({
  root: Schema.Record({ key: Schema.String, value: JsonValue }),
});
export type LexicalEditorStateJson = Schema.Schema.Type<
  typeof LexicalEditorStateJson
>;
